import script from "./WebinarStudioOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarStudioOffers.vue?vue&type=script&setup=true&lang=js"

import "./WebinarStudioOffers.vue?vue&type=style&index=0&id=c2479df0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2479df0"]])

export default __exports__